module.exports = __webpack_public_path__ + "img/ny-bannar2.91689935.jpg";